import { Rectangle } from '@/utils/geometry'

let ctx: CanvasRenderingContext2D | null = null
export const initMapPaddingsDebugger = () => {
  let enabled = false
  try {
    enabled = localStorage.getItem('____map-paddings-debugger') === 'true'
  } catch {
    /* ignore */
  }
  if (!enabled) return

  const canvas = document.createElement('canvas')
  canvas.width = window.innerWidth
  canvas.height = window.innerHeight
  window.addEventListener('resize', () => {
    canvas.width = window.innerWidth
    canvas.height = window.innerHeight
  })
  canvas.style.position = 'fixed'
  canvas.style.top = '0'
  canvas.style.left = '0'
  canvas.style.pointerEvents = 'none'
  canvas.style.zIndex = '9999'
  document.body.appendChild(canvas)

  ctx = canvas.getContext('2d')
}
export const mapPaddingsDebugger = {
  drawGeometryResults: (rects: Rectangle[], bestRect: Rectangle | null) => {
    if (!ctx) return
    ctx.clearRect(0, 0, window.innerWidth, window.innerHeight)
    for (const rect of rects) {
      ctx.strokeStyle = 'rgba(0, 255, 255, 0.5)'
      ctx.lineWidth = 20
      ctx.fillStyle = 'rgba(0, 255, 255, 0.5)'
      ctx.strokeRect(rect.x, rect.y, rect.width, rect.height)
      ctx.fill()
    }
    if (bestRect) {
      ctx.strokeStyle = 'rgba(255, 0, 0, 0.5)'
      ctx.fillStyle = 'rgba(255, 0, 0, 0.5)'
      ctx.lineWidth = 20
      ctx.strokeRect(bestRect.x, bestRect.y, bestRect.width, bestRect.height)
    }
  },
}
